import { render, staticRenderFns } from "./MarketDirect.vue?vue&type=template&id=a3938c42&scoped=true&"
import script from "./MarketDirect.vue?vue&type=script&lang=js&"
export * from "./MarketDirect.vue?vue&type=script&lang=js&"
import style0 from "./MarketDirect.vue?vue&type=style&index=0&id=a3938c42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3938c42",
  null
  
)

export default component.exports